<template>
  <div class="animated fadeIn">
    <AddBoard ref="AddBoard" v-on:Back="onBackAddBoard" v-if="hasNewBoard"/>
    <AddEmployee ref="AddEmployee" v-on:Back="onBackAddEmployee" v-if="hasNewEmployee"/>
    <Tables ref="tableGrid" v-show="hasNewBoard === false && hasNewEmployee == false"
      :columns="[
        $lang.EmployeeBoard.Board.DataTable.Code,
        $lang.EmployeeBoard.Board.DataTable.Employee,
        $lang.EmployeeBoard.Board.DataTable.Role,
        $lang.EmployeeBoard.Board.DataTable.Situation,
        $lang.EmployeeBoard.Board.DataTable.Admission,
        $lang.EmployeeBoard.Board.DataTable.FirstPeriod,
        $lang.EmployeeBoard.Board.DataTable.SecondPeriod,
        $lang.EmployeeBoard.Board.DataTable.EarlyWarning,
        $lang.EmployeeBoard.Board.DataTable.Vacation,
        $lang.EmployeeBoard.Board.DataTable.MedicalLeave,
        $lang.EmployeeBoard.Board.DataTable.MealQuantityPerDay,
        $lang.EmployeeBoard.Board.DataTable.MealValuePerDay,
        $lang.EmployeeBoard.Board.DataTable.MealValuePerMonth,
        $lang.EmployeeBoard.Board.DataTable.Breakfest,
        $lang.EmployeeBoard.Board.DataTable.TransportVouchersQuantity,
        $lang.EmployeeBoard.Board.DataTable.TransportVouchersValue,
        $lang.Common.DataTable.Actions]"
      :showFullscreen="false"
      :showHistory="true"
      :showPrint="true"
      :showDownload="false"
      :messageTipFooter="$lang.Common.ClickToSelect"
      :pagingLimitDefault="pagingLimit"
      v-on:Print="onPrint"
      v-on:Load="onSearch"
      v-on:History="onHistory"
      v-on:ChangePagingLimit="onChangePagingLimit">
      <template slot="formBeforeTable">
        <BoardDetails v-if="showHistory === false" ref="BoardDetails"
          v-on:New="onAddBoard"
          v-on:Edit="onEditBoard"
          v-on:Delete='onDeleteBoard'
          v-on:SectionApproval="onSectionApproval"
          v-on:Approval="onApproval"
          v-on:Disapproval="onDisapproval"
          v-on:Clone="onClone"
          v-on:Export="onExport"
          v-show="hasBoard"
          :obj="objSelected"/>
        <BoardHistory v-else :value="dataHistory" v-on:CloseHistory="showHistory = false" ref="BoardHistory" />
      </template>
      <template slot="header">
        <tr>
          <th class="text-center"><b-button size="sm" :pressed="order === 1" @click="onOrder(1)"><i class="fas fa-sort-numeric-down"></i></b-button></th>
          <th class="text-center"><b-button size="sm" :pressed="order === 2" @click="onOrder(2)"><i class="fas fa-sort-alpha-down"></i></b-button></th>
          <th colspan="3" class="text-center">&nbsp;</th>
          <th colspan="2" class="text-center" style="border-left: 1px; border-right: 1px;"> {{$lang.EmployeeBoard.Board.DataTable.ExperienceContract}} </th>
          <th colspan="3" class="text-center">&nbsp;</th>
          <th colspan="3" class="text-center"> {{$lang.EmployeeBoard.Board.DataTable.FoodAid}} </th>
          <th colspan="1" class="text-center">&nbsp;</th>
          <th colspan="2" class="text-center"> {{$lang.EmployeeBoard.Board.DataTable.TransportVouchers}} </th>
          <th colspan="1" class="text-center">&nbsp;</th>
        </tr>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.ID">
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.funcionario ? obj.funcionario.codigo.toString() : ''" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.funcionario ? obj.funcionario.nome : ''" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.funcionario && obj.funcionario.cargo ? obj.funcionario.cargo.nome : ''" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.situacao" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.admissao" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataExperiencia1" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataExperiencia2" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.avisoPrevio" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.ferias" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataAfastamento" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.refeicaoQuantidade.toString()" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="formatMoney(obj.refeicaoValorUnitario)" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="formatMoney(obj.valeAlimentacao)" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="formatMoney(obj.cafeManhaValor)" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.valeTransporteQuantidade.toString()" />
        <TableColumn :IsText="true"     v-on:Edit="onEdit(obj)" :status="obj.status" :value="formatMoney(obj.valeTransporteValorUnitario)" />
        <TableColumn :IsActionsButtons="hasActionsButtons"  :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
      <template slot="tfoot">
        <tr v-if="this.objList && this.objList.length > 0" style="background-color: #fafafa;">
          <td colspan="10" class="text-center">&nbsp;</td>
          <td class="text-center"><strong>{{totalRefeicaoQuantidade}}</strong></td>
          <td class="text-center"><strong>{{totalRefeicaoValorUnitario}}</strong></td>
          <td class="text-center"><strong>{{totalValeAlimentacao}}</strong></td>
          <td class="text-center"><strong>{{totalCafeManhaValor}}</strong></td>
          <td class="text-center"><strong>{{totalValeTransporteQuantidade}}</strong></td>
          <td class="text-center"><strong>{{totalValeTransporteValorUnitario}}</strong></td>
          <td class="text-center">&nbsp;</td>
        </tr>
      </template>
      <template slot="footer">
        <div class="form-group row pt-3">
          <div class="col-md-12 pl-3">
            <button v-if="canNewEmployee" type="button" class="btn btn-default btn-sm text-secondary" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNewEmployee" @click="onAddEmployee">
              <i class="fas fa-user-plus"></i> {{$lang.EmployeeBoard.Board.ButtonEmployes}}
            </button>
          </div>
        </div>
      </template>
    </Tables>
    <DisapprovalModal ref="DisapprovalModal" v-on:Disapproval="onDisapprovalSave"/>
  </div>
</template>
<script>
import Board from './board.js'
export default Board
</script>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/board/board.vue